<template>
<div class="sso-configuration-list">
<div class="container-fluid">
    <div class="table-responsive margin-Top-6Perc overflow-x-hidden">
      <table class="table table-striped ">
          <thead>
            <tr>
              <!-- <th class="text-align-center font-size-15px"></th> -->
              <th class="text-align-center font-size-15px border-right">Client</th>
              <th class="text-align-center font-size-15px border-right">Domain</th>
              <th class="text-align-center font-size-15px border-right">Auth Mode</th>
              <th class="text-align-center font-size-15px border-right">SSO Login URL</th>
              <th class="text-align-center font-size-15px border-right">Created TS</th>
              <th class="text-align-center font-size-15px">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="ssoObj in getSSOList" :key="ssoObj.SSOConfigId" v-bind:ssoObj = "ssoObj" >
              <td class="border-right">{{ssoObj.ClientName}}</td>
              <td class="border-right">{{ssoObj.Domain}}</td>
              <td class="border-right">{{formatAndShowAuthType(ssoObj.AuthMode)}}</td>
              <td class="border-right text-decoration-underline"><a :href="ssoObj.SSOLoginUrl" target="_blank">{{ssoObj.SSOLoginUrl}}</a></td>
              <td class="border-right">{{formatAndShowDate(ssoObj.CreatedTS)}}</td>
              <td>
                <a class="cursor-pointer" @click="openSelected($event, ssoObj, 'view')"> View</a> |
                <a class="cursor-pointer" @click="openSelected($event, ssoObj, 'edit')"> Edit</a> |
                <a class="cursor-pointer" @click="openSelected($event, ssoObj, 'delete')"> Delete</a>
              </td>
            </tr>
          </tbody>
       </table>
    </div>
  </div>
  <view-sso-configuration-overlay v-if="openViewSSOConfigOverlay" v-bind:selectedSSOConfigObj="selectedSSOConfigObj" @closeOverlay="closeOverlay"></view-sso-configuration-overlay>
  <update-sso-configuration-overlay v-if="openEditSSOConfigOverlay" v-bind:selectedSSOConfigObj="selectedSSOConfigObj" @closeOverlay="closeOverlay"></update-sso-configuration-overlay>
  <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="performAction"></confirmation-alert>
  <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
</div>
</template>
<script>
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import EditSSOConfigurationOverlay from '@/components/sso_configuration/EditSSOConfigurationOverlay'
import ViewSSOConfigurationOverlay from '@/components/sso_configuration/ViewSSOConfigurationOverlay'
import { ssoConfigurationService } from '@/server-util/sso-configuration-service'
export default {
  props: ['ssoList'],
  data: function () {
    return {
      isChecked: false,
      selectedSSOConfigObj: null,
      showSpinner: false,
      showAlertDialog: false,
      errorMsg: '',
      showConfirmationBox: false,
      prefixString: 'Are you sure you want to delete ',
      postString: '',
      openEditSSOConfigOverlay: false,
      openViewSSOConfigOverlay: false
    }
  },
  computed: {
    getSSOList: {
      get: function () {
        return this.ssoList
      }
    }
  },
  name: 'sso-configuration-list',
  methods: {
    closeOverlay (value) {
      // AK: Use to close all overlays
      // alert(JSON.stringify(value))
      this.openEditSSOConfigOverlay = value.closeOverlay
      this.openViewSSOConfigOverlay = value.closeOverlay
      // AK: Enable background scrolling
      this.$store.state.isOverlayVisible = value.closeOverlay
      // AK: If user update SSO details then refresh list
      if (value.refreshList) {
        this.getSSOListFromServer()
      }
    },
    performAction (value) {
      this.showConfirmationBox = false
      // AK: delete selected SSO Configuration
      if (value) {
        this.deleteSelectedSSO()
      }
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of confirmation overlay
      this.showConfirmationBox = value
    },
    openSelected: function (event, selectedObj, operationToPerform) {
      // AK: set selected SSO Object
      this.selectedSSOConfigObj = selectedObj
      // AK: Enable background scrolling
      this.$store.state.isOverlayVisible = true
      switch (operationToPerform) {
        case 'view':
          this.openViewSSOConfigOverlay = true
          break
        case 'edit':
          this.openEditSSOConfigOverlay = true
          break
        case 'delete':
          this.postString = '\'' + this.selectedSSOConfigObj.ClientName + '\'?'
          this.showConfirmationBox = true
          break
      }
    },
    deleteSelectedSSO: function () {
      var storeObj = this.$store
      var _this = this
      if (this.selectedSSOConfigObj.SSOConfigId !== undefined && this.selectedSSOConfigObj.SSOConfigId !== null) {
        _this.$store.state.isLoading = true
        ssoConfigurationService
          .deleteSSO(
            storeObj.state.access_token,
            this.selectedSSOConfigObj.SSOConfigId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              this.getSSOListFromServer()
            } else {
              if (_this.$store.state.isLoading === true) {
                // AK: Hide Spinner
                _this.$store.state.isLoading = false
              }
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            if (_this.$store.state.isLoading === true) {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING SSO LIST'
        )
      }
    },
    getSSOListFromServer: function () {
      var storeObj = this.$store
      var _this = this
      if (storeObj.state.access_token !== undefined || storeObj.state.access_token !== null || storeObj.state.access_token !== '') {
        ssoConfigurationService.getSSOList(storeObj.state.access_token)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.ssoClientList = responseObj.data
              if (_this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving SSO list
                _this.$store.state.isLoading = false
              }
            } else {
              if (_this.$store.state.isLoading === true) {
                // AK: Hide Spinner
                _this.$store.state.isLoading = false
              }
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            if (_this.$store.state.isLoading === true) {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING SSO LIST'
        )
      }
    },
    formatAndShowDate: function (date) {
      var dateToPass = date
      if (dateToPass.indexOf('Z') === -1) {
        dateToPass += 'Z'
      }
      return dmAdminUtils.covertUtcToEst(dateToPass)
    },
    formatAndShowAuthType: function (mode) {
      var modeToShow = ''
      switch (parseInt(mode)) {
        case constants.AuthenticationType.SP_Initiated:
          modeToShow = 'SP Initiated'
          break
        case constants.AuthenticationType.IDP_Initiated:
          modeToShow = 'IDP Initiated'
          break
      }
      return modeToShow
    },
    updateViewEnrolledCoursesFlag (value) {
      // AK: used to close the overlay (view enrolled courses page) by pressing Close
      this.viewEnrolledCourses = value
      // AK: Enable Background Scrolling
      this.$store.state.isOverlayVisible = value
    },
    updateViewEnrolledCohortsFlag (value) {
      // AK: used to close the overlay (view enrolled cohort page) by pressing Close
      this.viewEnrolledCohorts = value
      // AK: Enable Background Scrolling
      this.$store.state.isOverlayVisible = value
    },
    updateViewEnrolledParticipantsFlag (value) {
      // AK: used to close the overlay (view enrolled Participant page) by pressing Close
      this.viewEnrolledParticipants = value
      // AK: Enable Background Scrolling
      this.$store.state.isOverlayVisible = value
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    }
  },
  components: {
    'confirmation-alert': ConfirmationOverlay,
    'alert-box': AlertBox,
    'update-sso-configuration-overlay': EditSSOConfigurationOverlay,
    'view-sso-configuration-overlay': ViewSSOConfigurationOverlay
  }
}
</script>
<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.text-align-left {
  text-align: left;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-Top-3Perc {
  margin-top: 3%;
}

.margin-Top-6Perc {
  margin-top: 6%;
}
.margin-left-1Perc {
  margin-left: 1%;
}
.margin-left-2Perc {
  margin-left: 2%;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.overflow-x-hidden {
  overflow-x: hidden !important;
}
.sso-configuration-list {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-left: inherit;
  padding-right: inherit;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.text-align-center {
  text-align: center !important;
}
.font-size-15px {
  font-size: 15px !important;
}
a{
  color: #2c3e50;
  text-decoration: none;
}
a:link {
  color: #2c3e50;
  text-decoration: none;
}
a:visited {
  color: #2c3e50;
  text-decoration: none;
}
a:hover {
  color: #2c3e50;
  text-decoration: none;
}
a:active {
  color: #2c3e50;
  text-decoration: none;
}
.btn-text-color {
  color: #2c3e50;
}
.cursor-pointer {
  cursor: pointer;
}
.text-decoration-underline {
  text-decoration: underline;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}
</style>


// WEBPACK FOOTER //
// src/components/sso_configuration/SSOConfigurationList.vue